import { useAngularServices } from '@/react/components'
import { cloneDeep } from 'lodash'
import { ApplicationConfig } from '@/react/types'

export const useGetMobileApps = (): ApplicationConfig[] => {
  const { $rootScope } = useAngularServices()

  return cloneDeep($rootScope.mobile_apps)
}
